module.exports = __webpack_public_path__ + "img/map.228aba8b.png";